import React, { useEffect, useState } from "react";
import "./Testimonials.css";
import api from "../Api.js";

export default function JoyrajTestimonials() {
  const [current, setCurrent] = useState(0);
  const [testimonial, setTestimonial] = useState([]);

  /* Fetch testimonials */
  useEffect(() => {
    const getTestimonials = async () => {
      try {
        const response = await api.get("/testimonials");
        if (response?.data?.status === true) {
          setTestimonial(response.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch testimonials", error);
      }
    };

    getTestimonials();
  }, []);

  /* Auto slide (only when data exists) */
  useEffect(() => {
    if (testimonial.length === 0) return;

    const timer = setInterval(() => {
      setCurrent((prev) =>
        prev === testimonial.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(timer);
  }, [testimonial]);

  const prevSlide = () => {
    if (testimonial.length === 0) return;
    setCurrent((prev) =>
      prev === 0 ? testimonial.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    if (testimonial.length === 0) return;
    setCurrent((prev) =>
      prev === testimonial.length - 1 ? 0 : prev + 1
    );
  };

  if (testimonial.length === 0) {
    return (
      <section className="joyraj-testimonial-section">
        <p className="joyraj-loading">Loading testimonials...</p>
      </section>
    );
  }

  /* Build a 3-card window starting at `current` (wraps around) */
  const visibleTestimonials = [0, 1, 2].map(
    (offset) => testimonial[(current + offset) % testimonial.length]
  );

  return (
    <section className="joyraj-testimonial-section">
      <div className="joyraj-testimonial-wrapper">
        <div className="joyraj-testimonial-header">
          <h2>Testimonials</h2>
          <div className="joyraj-testimonial-controls">
            <button onClick={prevSlide} aria-label="Previous">‹</button>
            <button onClick={nextSlide} aria-label="Next">›</button>
          </div>
        </div>

        <div className="joyraj-testimonial-track">
          {visibleTestimonials.map((item, idx) => (
            <div
              className="joyraj-testimonial-card"
              key={`${current}-${idx}`}
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <img src={item?.photo_url} alt={item?.name} />
              <p className="joyraj-review">“{item?.comment}”</p>
              <h4>{item?.name}</h4>
              <span>{item?.designation}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}